import Drawer from "../drawer/Drawer.jsx";
import colorSchema from "../../assets/kits/colors";
import useWindowSize from "../../hooks/useWindowSize.jsx";
import { CloseIcon } from "../kits/Icons/Icons.tsx";
import { addCommas } from "@persian-tools/persian-tools";
import "./check-out.scss";
export default function ProductDetailDrawer({ isOpen, setIsOpen, items }) {
  const winSize = useWindowSize();
  {
    /* checkout cartItem drawer */
  }

  return (
    <Drawer
      height={winSize.height > items.length * 37 + 61 ? "auto" : Infinity}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <div className="mr-b-24">
        <div className=" d-flex justify-content-between ">
          <h3
            className="title-h3-b mr-r-20 mr-t-16 mr-b-8"
            style={{ color: colorSchema.foreground_background_he }}
          >
            اقلام سفارش
          </h3>
          {winSize.height < items.length * 37 + 131 && (
            <button
              className="btn"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <CloseIcon className="txt-t1-l fs-3 " />
            </button>
          )}
        </div>
        {items.map((value, index) => {
          return (
            <div
              className="d-flex justify-content-between mr-x-20 mr-t-16"
              key={`product_${index}`}
            >
              <div
                className="title-h5-m d-flex"
                style={{ color: colorSchema.foreground_background_he }}
              >

                <span className="productTitle">{value.product_info.title}</span>
                <span> (x{value.current_count})</span>
              </div>
              <div
                className="desc-m mr-r-32"
                style={{
                  color: colorSchema.foreground_background_he,
                  whiteSpace: "nowrap"
                }}
              >
                {addCommas(((value.apo_info.discount != "0" ) ?value.apo_info.discount : value.apo_info.price) * value.current_count)} تومان
              </div>
            </div>
          );
        })}
      </div>
    </Drawer>
  );
}
